"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n\n  white-space: nowrap;\n\n  text-align: center;\n\n  line-height: 1;\n  font-weight: ", ";\n\n  color: ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  @media (min-width: ", ") {\n    text-align: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n"])), function (p) {
  return p.marginBottom || 0;
}, function (p) {
  return p.isBold ? p.theme.fontWeightBold : p.theme.fontWeightSemibold;
}, function (p) {
  return p.isLabel ? p.theme.colorLabel : p.theme.colorText;
}, function (p) {
  return p.size === "sm" && "font-size: 0.635rem";
}, function (p) {
  return p.size === "md" && "font-size: 0.75rem";
}, function (p) {
  return p.size === "lg" && "font-size: 0.925rem";
}, function (p) {
  return p.size === "xl" && "font-size: 1.625rem";
}, function (props) {
  return props.theme.screenWidthXxs;
}, function (p) {
  return p.textAlign || "left";
}, function (p) {
  return p.size === "sm" && "font-size: 0.635rem";
}, function (p) {
  return p.size === "md" && "font-size: 0.675rem";
}, function (p) {
  return p.size === "lg" && "font-size: 0.75rem";
}, function (p) {
  return p.size === "xl" && "font-size: 1.25rem";
});

var Wrapper = function Wrapper(_ref) {
  var className = _ref.className,
      children = _ref.children,
      marginBottom = _ref.marginBottom,
      size = _ref.size,
      isBold = _ref.isBold,
      isLabel = _ref.isLabel,
      textAlign = _ref.textAlign;
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, {
    className: className,
    marginBottom: marginBottom,
    size: size,
    isBold: isBold,
    isLabel: isLabel,
    textAlign: textAlign
  }, children);
};

var _default = Wrapper;
exports.default = _default;